export enum IconType {
  Emoji = 'emoji',
  AffineIcon = 'affine-icon',
  Blob = 'blob',
}

export type IconData =
  | {
      type: IconType.Emoji;
      unicode: string;
    }
  | {
      type: IconType.AffineIcon;
      name: string;
      color: string;
    }
  | {
      type: IconType.Blob;
      /** In-memory blob (lost on JSON serialization) */
      blob?: Blob;
      /** Persistent URL (data URL or asset URL) — survives JSON storage */
      url?: string;
    };
